import React from 'react';
import { Shield, Award, Target, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            About Claim A Trademark
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Your trusted partner in protecting and securing brand identities through expert trademark registration services.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1507679799987-c73779587ccf"
              alt="Professional trademark registration expertise and legal services"
              className="rounded-2xl shadow-xl w-full h-[500px] object-cover"
            />
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-emerald-900">
              Trademark Excellence You Can Trust
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Claim A Trademark is a leading trademark registration service specializing in helping businesses, entrepreneurs, and individuals protect their brand identities through federal trademark registration with the United States Patent and Trademark Office (USPTO).
            </p>
            <p className="text-gray-700 leading-relaxed">
              We've successfully filed over 1,000 trademarks across diverse industries, from tech startups to established enterprises. Our team of experienced trademark attorneys and specialists brings deep expertise in USPTO procedures, trademark law, and brand protection strategies that help our clients secure their intellectual property with confidence.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We understand that your brand is your most valuable asset. That's why we're committed to providing transparent, affordable, and comprehensive trademark services that give you peace of mind and legal protection for your business identity. Our proven track record and personalized approach ensure your trademark registration is handled with the expertise and attention it deserves.
            </p>
          </div>
        </div>

        {/* Mission & Values */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Card className="border-emerald-200 hover:shadow-lg transition-all duration-300 hover:border-amber-500">
            <CardContent className="p-6 text-center">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-emerald-700" />
              </div>
              <h4 className="text-xl font-bold text-emerald-900 mb-2">Expert Protection</h4>
              <p className="text-gray-600">
                Specialized expertise in federal trademark registration and brand protection.
              </p>
            </CardContent>
          </Card>

          <Card className="border-emerald-200 hover:shadow-lg transition-all duration-300 hover:border-amber-500">
            <CardContent className="p-6 text-center">
              <div className="bg-amber-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="h-8 w-8 text-amber-700" />
              </div>
              <h4 className="text-xl font-bold text-emerald-900 mb-2">Proven Success</h4>
              <p className="text-gray-600">
                98% client satisfaction with over 1,000 successful trademark registrations.
              </p>
            </CardContent>
          </Card>

          <Card className="border-emerald-200 hover:shadow-lg transition-all duration-300 hover:border-amber-500">
            <CardContent className="p-6 text-center">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="h-8 w-8 text-emerald-700" />
              </div>
              <h4 className="text-xl font-bold text-emerald-900 mb-2">Transparent Process</h4>
              <p className="text-gray-600">
                Clear pricing, no hidden fees, and step-by-step guidance throughout.
              </p>
            </CardContent>
          </Card>

          <Card className="border-emerald-200 hover:shadow-lg transition-all duration-300 hover:border-amber-500">
            <CardContent className="p-6 text-center">
              <div className="bg-amber-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-amber-700" />
              </div>
              <h4 className="text-xl font-bold text-emerald-900 mb-2">Dedicated Support</h4>
              <p className="text-gray-600">
                Personalized service with dedicated case managers for every client.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
